import { httpAPI } from "@/api/httpAPI";

import lists from './lists'
import dialogs from './dialogs'
import references from './references';

const orders = {
    namespaced: true,
    state: {
        currentCollection: null,
        updateCounterInProcess: false,
        counters: [],
        personalReceptionTypes: [
            { id: 0, Value: 'Личный_прием' },
            { id: 1, Value: 'Выездной_личный_прием' }
        ],
    },
    mutations: {
        SET_CURRENT_COLLECTION(state, payload) {
            state.currentCollection = payload;
        },
        SET_UPDATE_IN_PROCESS(state, payload) {
            state.updateCounterInProcess = payload;
        },
        SET_COUNTERS(state, payload){
            state.counters = payload;
        }
    },
    getters: {
        getCurrentCollection: (s) => s.currentCollection,
        isCountersLoading: (s) => s.updateCounterInProcess,
        getMyOrdersOnExecutionCounter: (s) => s.counters.find(x => x[0] === "11")?.[2] ?? -1,
        getMyOrdersOnExecutionUnreadedCounter: (s) => s.counters.find(x => x[0] === "11")?.[3] ?? -1,
        getMyOrdersOnCheckCounter: (s) => s.counters.find(x => x[0] === "12")?.[2] ?? -1,
        getMyOrdersOnCheckUnreadedCounter: (s) => s.counters.find(x => x[0] === "12")?.[3] ?? -1,
        getMyProcessesOnAdjustmentCounter: (s) => s.counters.find(x => x[0] === "13")?.[2] ?? -1,
        getMyProcessesOnAdjustmentUnreadedCounter: (s) => s.counters.find(x => x[0] === "13")?.[3] ?? -1,
        getMyProcessesExecutionControlCounter: (s) => s.counters.find(x => x[0] === "14")?.[2] ?? -1,
        getMyProcessesExecutionControlUnreadedCounter: (s) => s.counters.find(x => x[0] === "14")?.[3] ?? -1,
        getMyControlOrdersCounter: (s) => s.counters.find(x => x[0] === "21")?.[2] ?? -1,
        getMyControlUnreadedOrdersCounter: (s) => s.counters.find(x => x[0] === "21")?.[3] ?? -1,
        getMyControlTasksCounter: (s) => s.counters.find(x => x[0] === "22")?.[2] ?? -1,
        getMyControlUnreadedTasksCounter: (s) => s.counters.find(x => x[0] === "22")?.[3] ?? -1,        
        getMyProcessesOnProlongationCounter: (s) => s.counters.find(x => x[0] === "15")?.[2] ?? -1,
        getMyProcessesOnProlongationUnreadCounter: (s) => s.counters.find(x => x[0] === "15")?.[3] ?? -1,
        getProtocolDocumentTypes: () => ({ 0: 'Протокол', 1: 'Протокол_личного_приема' }),
        getPersonalReceptionTypes: (s) => s.personalReceptionTypes,
        getPersonalReceptionTypesObject: (s) => s.personalReceptionTypes.reduce((a, v) => ({ ...a, [v.id]: v.Value }), {}),
        getProtocolCounter: (s) => s.counters.find(x => x[0] === "31")?.[2] ?? -1,
        getProtocolUnreadCounter: (s) => s.counters.find(x => x[0] === "31")?.[3] ?? -1,
        getInnerOrdersCounter: (s) => s.counters.find(x => x[0] === "32")?.[2] ?? -1,
        getInnerOrdersUnreadCounter: (s) => s.counters.find(x => x[0] === "32")?.[3] ?? -1,
        getOuterOrdersCounter: (s) => s.counters.find(x => x[0] === "33")?.[2] ?? -1,
        getOuterOrdersUnreadCounter: (s) => s.counters.find(x => x[0] === "33")?.[3] ?? -1,
        
    },
    actions:{
        async updateCounter({commit, state}) {
            if (!state.updateCounterInProcess) {
                commit('SET_UPDATE_IN_PROCESS', true);

                try
                {
                    let response = await httpAPI({ url: `api/orders/counter`, method: 'GET' });
                    commit('SET_COUNTERS', response?.data?.Payload?.Categories ?? []);
                }
                finally
                {
                    commit('SET_UPDATE_IN_PROCESS', false);
                }
            }
        },
    },
    modules: {
        lists,
        dialogs,
        references,
    }
}

export default orders;